import { GeoFence } from '../../../../domain/geoFence/GeoFence';
import { GeoFenceDTO } from '../../../../domain/geoFence/GeoFenceDTO';
import { SearchFilter } from '../filter';
import { SearchFilterProps } from '../filter/SearchFilter';

export type SearchFilterGeojsonOperator = `in` | `nin`;
export type SearchFilterGeojsonValue = GeoFence[];
export interface SearchFilterGeojsonOptionProps {
  value: GeoFenceDTO;
}

interface SearchFilterGeojsonProps extends SearchFilterProps {
  field: string;
  operator: SearchFilterGeojsonOperator;
  listOptions: SearchFilterGeojsonOptionProps[];

  // - "is unknown" => unknown (value es null)
  // - "has any value" => known (value es null)
}

export class SearchFilterGeojson extends SearchFilter {
  private listOptions: SearchFilterGeojsonOptionProps[];

  constructor({ listOptions, ...props }: SearchFilterGeojsonProps) {
    super({ ...props, type: `geojson` });
    this.listOptions = listOptions;
  }

  public getListOptions(): SearchFilterGeojsonOptionProps[] {
    return this.listOptions;
  }
}
